module.exports = __webpack_public_path__ + "media/categories-photos/22-fb54c13e.webp";